/**
 * Data testimoni (structured content).
 *
 * PENTING: JANGAN membuat testimoni palsu.
 * Section testimoni otomatis DISEMBUNYIKAN selama array ini kosong.
 * Tambahkan testimoni asli di sini ketika sudah tersedia:
 *
 * {
 *   id: "t-1",
 *   name: "Nama Pelanggan",
 *   company: "Nama Perusahaan",
 *   position: "Jabatan",
 *   quote: "Isi testimoni...",
 *   logo: "",   // opsional
 *   photo: "",  // opsional
 * }
 */
export const testimonials = [];

export default testimonials;
